module.exports = ".list-group-item .icon{\n    margin-right: unset;\n}\n\n.block_groups_type {\n    padding-top: 15px;\n    overflow-x: hidden;\n    -webkit-box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n            box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    height: calc(100vh - 48px);\n    background-color: #fff;\n    border-radius: 8px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/admin/icontact/setting/tickets/ticket-type/ticket-type.component.css
// module id = ./src/app/pages/admin/icontact/setting/tickets/ticket-type/ticket-type.component.css
// module chunks = main